<template>
 <Head>
    <title> View Staff | {{$page.props.appName}}</title>
    <meta name="description" :content="'Create Staff' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="clearfix">
      <Link
        href="/admin/staff/create"
        class="bg-black text-white font-bold uppercase p-3 rounded mt-3"
        as="button"
        type="button"
      >
        CREATE STAFF
      </Link>
    </div>
    <search-filter v-model:search="this.form.search"
      class="w-full max-w-md mr-4"
      @reset="reset"
    >
    
    </search-filter>
    <div class="mt-2 rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap bg-gray-100">
        <tr class="text-center font-bold p-2">
          <th class="px-6 pt-6 pb-4">Username</th>

          <th class="px-6 pt-6 pb-4">Forename</th>

          <th class="px-6 pt-6 pb-4">Middlename</th>

          <th class="px-6 pt-6 pb-4">Surname</th>

          <th class="px-6 pt-6 pb-4">Site</th>

          <th class="px-6 pt-6 pb-4">Department</th>

          <th class="px-6 pt-6 pb-4">Phone Number</th>

          <th class="px-6 pt-6 pb-4">National Insurance Number</th>

          <th class="px-6 pt-6 pb-4">Driving License Number</th>

          <th class="px-6 pt-6 pb-4">Email</th>
        </tr>

        <Link as="tr"
          v-for="user in staff.data"
          :key="user.id"
          :href="'/admin/skills/'+user.id" 
          class="hover:bg-gray-200 focus-within:bg-gray-200 text-center  cursor-pointer p-2"
        >
          <td class="border-t">
            {{ user.username }}
          </td>

          <td class="border-t">
            {{ user.first_name }}
          </td>

          <td class="border-t">
            {{ user.middle_name }}
          </td>

          <td class="border-t">
            {{ user.surname }}
          </td>

          <td class="border-t">
            {{ user.site }}
          </td>

          <td class="border-t">
            {{ user.department }}
          </td>

          <td class="border-t">
            {{ user.phone_number }}
          </td>

          <td class="border-t">
            {{ user.national_insurance_number }}
          </td>

          <td class="border-t">
            {{ user.driving_license_number }}
          </td>

          <td class="border-t">
            {{ user.email }}
          </td>
          <td class="border-t w-px" v-if="user.deleted==null">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="block w-6 h-6 fill-gray-400"
            >
              <polygon
                points="12.95 10.707 13.657 10 8 4.343 6.586 5.757 10.828 10 6.586 14.243 8 15.657 12.95 10.707"
              ></polygon>
            </svg>
          </td>
        </Link>

        <tr v-if="staff.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No staff found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="staff.links" :pagination="this.pagination" :search="this.form.search"/>
    
    <div class="float-right">
           <label for="" class="text-xs block">Items per page</label>
            <select name="" id="" class="select-form block" v-model="paginationsetting" @change="paginationChange()">
              <option value="1">1</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import SearchFilter from "@/Shared/SearchFilter";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  props: {
    filters: Object,
    staff: Object,
    pagination : String
  },
  components: {
    Pagination,
    SearchFilter,
    Link,
    Head
  },
  data() {
    return {
      paginationsetting: this.pagination,
      form: {
        search: this.filters.search,
      },
    };
  },
  watch: {
    form : {
        handler: throttle(function() {
        this.$inertia.get('/admin/staff', pickBy(this.form), { preserveState: true})
      }, 150),
        deep : true
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    paginationChange(){
      if(this.form.search!==null){
        this.$inertia.get('/admin/staff?search=' + this.form.search + '&pagination=' + this.paginationsetting, { preserveState: true })
      }else {
            this.$inertia.get('/admin/staff?pagination=' + this.paginationsetting, { preserveState: true })

      }

    }
  },
};
</script>